// extracted by mini-css-extract-plugin
export default {"PlanSummarySection":"PlanSummarySection_PlanSummarySection__RpFgi"};